/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_MessageInputs */

const en_contact_form_message = /** @type {(inputs: Contact_Form_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

const pl_contact_form_message = /** @type {(inputs: Contact_Form_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiadomość`)
};

/**
* | output |
* | --- |
* | "Message" |
*
* @param {Contact_Form_MessageInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_form_message = /** @type {((inputs?: Contact_Form_MessageInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_MessageInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_form_message(inputs)
	return en_contact_form_message(inputs)
});